import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

// export const answerReportProblem: ApiMethod<
//   Content.AnswerReportProblemInput,
//   void,
//   any
// > = async (data, { dispatch, rejectWithValue }) => {
//   try {
//     const client = new Content.Content_ReportProblem_Client(
//       undefined,
//       contentClient
//     );
//     const response = await client.reportProblem_answer_V1(data);
//     if (response.success) {
//       return;
//     }
//     return rejectWithValue(response.errors);
//   } catch (error: any) {
//     console.log('getAllPolicies', error);
//     // Show alert
//     const errors = { ...error.response }.data;
//     dispatch(
//       CommonActions.setAlert({
//         type: AlertType.WARNING,
//         messages: JSON.parse(errors).errors || [
//           { message: 'Something went wrong' },
//         ],
//       })
//     );

//     return rejectWithValue(error);
//     throw error;
//   }
// };

export const createReportProblemOption: ApiMethod<
  Server.CreateReportProblemOptionInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ReportProblem_Client(
      undefined,
      contentClient
    );
    const response = await client.admin_ReportProblem_options_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const updateReportProblemOption: ApiMethod<
  Server.UpdateReportProblemOptionInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ReportProblem_Client(
      undefined,
      contentClient
    );
    const response = await client.admin_ReportProblem_options_put_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const deleteReportProblemOption: ApiMethod<number, void, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_ReportProblem_Client(
      undefined,
      contentClient
    );
    const response = await client.admin_ReportProblem_options_delete_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getAllReportProblemOptions: ApiMethod<
  void,
  Server.ReportProblemOptionOutput[],
  any
> = async (_, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ReportProblem_Client(
      undefined,
      contentClient
    );
    const response = await client.reportProblem_options_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getAllReportProblemAsDataTable: ApiMethod<
  Server.ReportProblemDatatable,
  Server.TableOfReportProblemColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ReportProblem_Client(
      undefined,
      contentClient
    );
    const response = await client.admin_ReportProblem_datatable_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
